import { IsTheme } from '../app/interfaces/is-theme';

export const defaultTheme: IsTheme = {
	id: 0,
	name: 'Brains',
	logoUrl: '',
	primaryColor: '#00B050',
	secondaryColor: '#007481',
	tertiaryColor: '#2F4858',
	webHeaderColor: '#FFFFFF',
};
